import React from "react";
import { Grid } from "@mui/material";
import AddRequiredSkills from "./AddRequiredSkills";
import SalaryRange from "./SalaryRange";

function SkillsAndSalary({
  control,
  preloadedData,
  filterOptions,
  skills,
  setOpenSkillDialog,
  setError,
  clearErrors,
  minimumSalary,
  maximumSalary
}) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <AddRequiredSkills
          control={control}
          preloadedData={preloadedData}
          filterOptions={filterOptions}
          skills={skills}
          setOpenSkillDialog={setOpenSkillDialog}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <SalaryRange
          control={control}
          setError={setError}
          clearErrors={clearErrors}
          preloadedData={preloadedData}
          minimumSalary={minimumSalary}
          maximumSalary={maximumSalary}
        />
      </Grid>
    </Grid>
  );
}

export default SkillsAndSalary;
